import { observable, set } from 'mobx';

export interface INodeData {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: string | any;
}

export interface INodeContent {
    nid: number;
    layout: string;
    data: INodeData[];
}

export interface IMantleMedia {
    src: string;
    alt: string;
    device_mp4_url: string;
    hex: string;
    background_color_fallback: string;
    html: string;
}

export interface IMantleRichText {
    html_tag: string;
    font_classes: string;
    text_content: string;
    html: string;
}

export interface IMantleCtaButton {
    href: string;
    text: string;
    classname: string;
    color_vals: boolean;
    bgcolor: string;
    textcolor: string;
    bordercolor: string;
    trigger_type: string;
    open_new_window: boolean;
}

export interface IImage {
    src: string;
    alt: string;
    html: string;
}

export interface IHexColor {
    hex: string;
}

export class Node {
    @observable public nid: number;
    @observable public layout: string;
    @observable public data: INodeData[] = [];

    public static fromJson(data: INodeContent): INodeContent {
        const node = new Node();
        set(node, data);

        node.nid = data.nid;
        node.layout = data.layout;
        node.data = data.data;

        return node;
    }
}
